import { CampanhaStatus } from '../enum/campanha-status.enum';
import { TipoDestinoCampanha } from '../enum/tipo-destino-campanha.enum';
import { Plano } from './plano.model';

export interface CampanhaFormValue {
  id?: string;
  /** Somente leitura: status atual da campanha (edição); ausente na criação, nunca é enviado de volta. */
  status?: CampanhaStatus;
  nome: string;
  nomeExibicao: string;
  descricao: string;
  instrucoes: string;
  dataInicio: string;
  dataFim: string;
  horarioInicio: string;
  horarioFim: string;
  participanteDataInicio: string;
  participanteHorarioInicio: string;
  /** Somente leitura: vem de `dtIntegracao` na resposta da API, nunca e enviado de volta. */
  dtIntegracao: string;
  selecionarTodosPlanos: boolean;
  planosAdicionados: Plano[];
  // Removido por solicitação do PO — manter comentado.
  // permitirReopcao: boolean;
  exibeTermo: boolean;
  /**
   * UI-only: seleciona o "tipo de termo" exibido no wireframe (catálogo com uma única opção).
   * Não existe campo correspondente na API (CampanhaResponseDto/CreateCampanhaCommandDto só têm
   * a flag exibeTermo) — por isso não é enviado nem lido pelo mapper. Vira campo real quando o
   * back-end expuser um identificador de termo (ex.: tpTermo/idTermo).
   */
  tipoTermo: string;
  // Removido por solicitação do PO — manter comentado.
  // importacaoObrigatoria: boolean;
  tipoDestino: TipoDestinoCampanha | '';
  destinoId: string;
  /** Perfil de investimento que serve de ponto de partida para participantes sem perfil ainda. */
  idPerfilInvestimentoDef: number | null;
  linkCampanha: string;
}

export function createCampanhaFormDefaultValue(): CampanhaFormValue {
  return {
    nome: '',
    nomeExibicao: '',
    descricao: '',
    instrucoes: '',
    dataInicio: '',
    dataFim: '',
    horarioInicio: '',
    horarioFim: '',
    participanteDataInicio: '',
    participanteHorarioInicio: '',
    dtIntegracao: '',
    selecionarTodosPlanos: false,
    planosAdicionados: [],
    // Removido por solicitação do PO — manter comentado.
    // permitirReopcao: false,
    exibeTermo: false,
    tipoTermo: '',
    // Removido por solicitação do PO — manter comentado.
    // importacaoObrigatoria: false,
    tipoDestino: '',
    destinoId: '',
    idPerfilInvestimentoDef: null,
    linkCampanha: '',
  };
}
